import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvertSelectionIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 3,
			fill: "currentColor",
			stroke: "none",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 3,
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", { d: "m14 7 2-2-2-2M16 5h-5M10 17l-2 2 2 2M8 19h5" })
	]
});
export default SvgInvertSelectionIcon;
